import React, { useEffect, useRef } from 'react'
import { useField } from '@unform/core'
import { debug } from 'console';

interface Props {
  name: string;
  label?: string;
  onlyNumbers?: boolean;
  mask?:string;
}

type InputProps = JSX.IntrinsicElements['input'] & Props

export default function Input({ name, label, onlyNumbers, mask, type, ...rest }: InputProps) {

  const inputRef = useRef<HTMLInputElement>(null)

  const { fieldName, defaultValue, registerField, error } = useField(name)

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: ref => {
        return ref.current.value
      },
      setValue: (ref, value) => {
        ref.current.value = value
      },
      clearValue: ref => {
        ref.current.value = ''
      },
    })
  }, [fieldName, registerField])

  const onlynumber = (evt:any) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /^[0-9.]+$/;
    // var regex = /^[0-9.]+$/;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  const applyMask = (evt: any) => {
    var value = evt.currentTarget.value;
    value = value.replace(/\D/g, '');

    value = value.substring(0, 13);
  
    if (value.length <= 11) { // CPF
        value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, '$1.$2.$3-$4');
    } else { // CNPJ
        value = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, '$1.$2.$3/$4-$5');
    }

    evt.currentTarget.value = value;
  }

  return (
    <>
      <input
        ref={inputRef}
        defaultValue={defaultValue}
        type={type}
        onKeyPress={(e) => {
          if(mask){
            applyMask(e);
          }
          if (onlyNumbers) {
            onlynumber(e);
          }
          else if ((type !== "password") && (e.key === 'Enter' || e.key === "NumpadEnter")) {
            e.preventDefault();
            inputRef.current?.blur();
          }
        }}
        {...rest}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </>
  )
}